import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-slate-50 pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-45">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-46">
        {/* Two-column layout on desktop */}
        <div className="mx-auto max-w-6xl flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-47">
          {/* Left: Copy */}
          <div className="flex-1 text-center lg:text-left" data-id="element-48">
            <div className="mb-6 inline-flex items-center rounded-full bg-blue-50 px-3 py-1 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10" data-id="element-49">
              SOS Ansiedad
            </div>
            <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl lg:text-5xl mb-6 font-serif leading-tight" data-id="element-50">
              ¿Sentís que el aire no te alcanza? Frená el ataque de ansiedad en
              5 minutos.
            </h1>
            <p className="mt-6 max-w-xl text-lg leading-8 text-slate-600 font-sans" data-id="element-51">
              Para la mujer argentina que no puede apagar la cabeza ni para
              dormir. Ni pastillas, ni terapias de años: Calma funcional en 300
              segundos.
            </p>
            <div className="mt-10 flex items-center justify-center lg:justify-start gap-x-6" data-id="element-52">
              <a href="#oferta" onClick={e => {
              e.preventDefault();
              document.getElementById('oferta')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="inline-flex items-center justify-center rounded-lg font-bold transition-colors bg-blue-600 text-white hover:bg-blue-700 shadow-lg shadow-blue-500/20 h-14 px-10 text-xl w-full sm:w-auto" data-id="element-53">
                QUIERO MI KIT SOS AHORA
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-54" />
              </a>
            </div>
            <p className="mt-4 text-sm text-slate-500 text-center lg:text-left" data-id="element-55">
              Descarga inmediata • Acceso de por vida
            </p>
          </div>

          {/* Right: Product Mockup */}
          <div className="flex-1 flex items-center justify-center w-full max-w-lg lg:max-w-none" data-id="element-56">
            <div className="relative w-full" data-id="element-57">
              {/* Soft glow behind image */}
              <div className="absolute inset-0 -z-10 bg-blue-100 rounded-3xl blur-3xl opacity-50 scale-90" data-id="element-58"></div>
              <img src="https://cdn.magicpatterns.com/uploads/ieofY1sYRittGmMbu51h58/heylloyd-image-1771635543413.png" alt="Kit de Emergencia SOS Ansiedad — mockup del producto" className="w-full h-auto rounded-2xl shadow-2xl shadow-slate-300/60 object-cover" data-id="element-59" />
              {/* Floating badge */}
              <div className="absolute -bottom-4 -left-4 bg-white rounded-xl shadow-lg px-4 py-3 flex items-center gap-2 border border-slate-100" data-id="element-60">
                <span className="text-2xl" data-id="element-61">⏱️</span>
                <div data-id="element-62">
                  <p className="text-xs text-slate-500 font-sans" data-id="element-63">Calma en</p>
                  <p className="text-sm font-bold text-slate-900" data-id="element-64">5 minutos</p>
                </div>
              </div>
              {/* Floating badge 2 */}
              <div className="absolute -top-4 -right-4 bg-blue-600 text-white rounded-xl shadow-lg px-4 py-3 flex items-center gap-2" data-id="element-65">
                <span className="text-2xl" data-id="element-66">🧠</span>
                <div data-id="element-67">
                  <p className="text-xs text-blue-200 font-sans" data-id="element-68">21 técnicas</p>
                  <p className="text-sm font-bold" data-id="element-69">probadas</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 -z-10 w-full h-full max-w-7xl opacity-30 pointer-events-none" data-id="element-70">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl" data-id="element-71"></div>
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl" data-id="element-72"></div>
        <div className="absolute -bottom-8 left-1/2 w-72 h-72 bg-pink-200 rounded-full mix-blend-multiply filter blur-3xl" data-id="element-73"></div>
      </div>
    </section>;
}